// extracted by mini-css-extract-plugin
module.exports = {"kioskLayout":"KioskLayout_kioskLayout__1RZmw","kioskLayout_html_body":"KioskLayout_kioskLayout_html_body__odKU-","kioskLayout_root":"KioskLayout_kioskLayout_root__pbKjS"};